import styled from "@emotion/styled";
import {
  space,
  color,
  layout,
  flexbox,
  position,
  typography,
  border,
  shadow,
  background,
  grid,
} from "styled-system";

const Box = styled.div`
  box-sizing: border-box;
  ${space}
  ${color}
  ${layout}
  ${flexbox}
  ${position}
  ${typography}
  ${border}
  ${shadow}
  ${background}
  ${grid}
`;

export default Box;
